import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';

import { PanelDef } from 'app/shared/components/panels/panels.types';
import { Property } from 'app/modules/projects/projects.types';
import { Account } from 'app/core/models';

@Component({
  selector: 'property-panel-comments',
  templateUrl: './comments.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelsCommentsComponent {
  @Input() property: Property;
  @Input() account: Account;
  @Input() panelDef: PanelDef<any>;
  @Input() canEditPanelDef: boolean = true;
  @Output() onEditPanelDef: EventEmitter<any> = new EventEmitter();

  titleFieldDef: any;
  panelName: string;
  public editMode: boolean;
  changeTitleMode: boolean = false;

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.titleFieldDef = {
      name: 'panel_name',
      label: this.panelDef.title,
      type: 'text',
    };
  }

  toggleChangeTitleMode() {
    this.changeTitleMode = true;
  }

  toggleEditMode(editMode: boolean | null = null): void {
    if (editMode === null) {
      this.editMode = !this.editMode;
    } else {
      this.editMode = editMode;
    }
    this.changeTitleMode = false;

    this._changeDetectorRef.markForCheck();
  }

  cancelEdits(): void {
    this.toggleEditMode(false);
  }

  update(params) {
    let currentKey = Object.keys(params)[0];
    if (currentKey === 'panel_name') {
      this.panelName = params.panel_name;
    }
  }

  saveLayout(): void {
    if (this.panelName) {
      this.panelDef.title = this.panelName;
    }
    this.onEditPanelDef.emit(this.panelDef);
    this.toggleEditMode(false);
  }
}
